export default __webpack_public_path__ + "static/media/img9.2f06e4b3.jpeg";